import {MapboxUser} from "@core/model/mapbox-user";
import {Action, createReducer, on} from "@ngrx/store";
import {authActions} from "@core/ngrx/actions";
import {AppError} from "@core/model/app-error";
import _ from "lodash";

export interface State {
  loggedUser: MapboxUser,
  loggedOut: boolean
  authError: AppError
}

export const initialState: State = {
  loggedUser: null,
  loggedOut: false,
  authError: null
}

const authReducer = createReducer(initialState,
  on(authActions.login, (state, action) => {
    const user = _.cloneDeep(action.user);
    user.permissions = ["companies.admin"] // Temporary solution until we have real permissions from backend
    return {
      ...initialState,
      loggedUser: user,
      loggedOut: false
    };
  }),
  on(authActions.logout, (state, action) => {
    return {
      ...initialState,
      loggedUser: null,
      loggedOut: true
    };
  }),
  on(authActions.authError, (state, action) => {
    return {
      ...initialState,
      authError: action.error
    };
  }),
);

export function reducer(state: State | undefined, action: Action): any {
  return authReducer(state, action);
}


